// taken from https://gist.github.com/nmsdvid/8807205
function debounce(func, wait, immediate, ...args) {
	let timeout;
	return () => {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			timeout = null;
			if (!immediate) func.apply(context, args);
		}, wait);
		if (immediate && !timeout) func.apply(context, args);
	};
}

export default debounce;
